export default __webpack_public_path__ + "static/cameras-1-02c86ebaac93239d874a5a91c6c39900.png";